var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "notification_box question_details" },
        [
          _vm.debug === true
            ? _c("div", { staticClass: "row padding_rl20 class_question" }, [
                _c("div", { staticClass: "col-md-5 col-xs-5" }, [
                  _vm._v("Classification Question"),
                ]),
                _c("div", { staticClass: "col-md-3 col-xs-3" }, [
                  _vm._v("Response"),
                ]),
                _c("div", { staticClass: "col-md-1 col-xs-1" }, [
                  _vm._v("Level"),
                ]),
                _c("div", { staticClass: "col-md-2 col-xs-2" }, [
                  _vm._v("Interim Class/Class"),
                ]),
                _c("div", { staticClass: "col-md-1 col-xs-1" }, [
                  _vm._v("Rule Ref"),
                ]),
              ])
            : _c("div", { staticClass: "row padding_rl20 class_question" }, [
                _c("div", { staticClass: "col-md-8 col-xs-8" }, [
                  _vm._v("Classification Question"),
                ]),
                _c("div", { staticClass: "col-md-4 col-xs-4" }, [
                  _vm._v("Response"),
                ]),
              ]),
          _c("div", { staticClass: "hr-thin-summary" }),
          _vm._l(_vm.workflowDataArray, function (data, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "row padding_rl20",
                staticStyle: { "padding-top": "10px", "padding-bottom": "5px" },
              },
              [
                _vm.debug == true
                  ? _c("div", { staticClass: "class_question_summary" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-5 col-xs-5 class_question_summary",
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "service",
                              attrs: { href: "javascript:void(0);" },
                              on: {
                                click: function ($event) {
                                  return _vm.navigateBack(data.step - 1)
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: { innerHTML: _vm._s(data.question) },
                              }),
                            ]
                          ),
                          _c("i", { staticClass: "fas fa-redo" }),
                          _vm.info == true
                            ? _c(
                                "base-tooltip",
                                {
                                  attrs: {
                                    content: `Click to jump to Step -> ${data.step}`,
                                  },
                                },
                                [
                                  _c("span", { staticClass: "email_tooltip" }, [
                                    _c("i", {
                                      staticClass: "fa fa-question-circle",
                                    }),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "col-md-3 col-xs-3" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(data.classNote) },
                        }),
                      ]),
                      _c("div", { staticClass: "col-md-1 col-xs-1" }, [
                        _vm._v(_vm._s(data.level)),
                      ]),
                      _c("div", { staticClass: "col-md-2 col-xs-2" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(data.interimClass) },
                        }),
                        !data.classCode
                          ? _c("span", [
                              _vm._v("/"),
                              _c("span", {
                                domProps: { innerHTML: _vm._s(data.classCode) },
                              }),
                            ])
                          : _vm._e(),
                      ]),
                      _c("div", { staticClass: "col-md-1 col-xs-1" }, [
                        _vm._v(_vm._s(data.ruleRef)),
                      ]),
                    ])
                  : _c("div", { staticClass: "class_question_summary" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-8 col-xs-8" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "service",
                              attrs: { href: "javascript:void(0);" },
                              on: {
                                click: function ($event) {
                                  return _vm.navigateBack(data.step - 1)
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: { innerHTML: _vm._s(data.question) },
                              }),
                            ]
                          ),
                          _vm.info == true
                            ? _c(
                                "base-tooltip",
                                {
                                  attrs: {
                                    content: `Click to Go Back to Step -> ${data.step}`,
                                  },
                                },
                                [
                                  _c("span", { staticClass: "email_tooltip" }, [
                                    _c("i", {
                                      staticClass: "fa fa-question-circle",
                                    }),
                                    _c("i", {
                                      staticClass: "fa fa-undo",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "col-md-4 col-xs-4" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(data.answer) },
                        }),
                      ]),
                    ]),
                _c("div", {
                  staticClass: "row padding_rl20 hr-thin-separator",
                }),
              ]
            )
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }